import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import useSWR from 'swr';
import { useAuthContext } from '@/context/AuthContext';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useWorldCommunityContext } from '@/context/WorldCommunityContext';
import { checkIsFollowed } from '@/lib/community';
import { AuthenticatedCommunityIdentity, getAuthenticatedFollowingsList, postAuthenticatedFollow, postAuthenticatedUnfollow } from '@/services/community';
export const useToggleFollow = () => {
  const $ = _c(19);
  const [isFollowed, setIsFollowed] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(true);
  const {
    setFollowersData
  } = useWorldCommunityContext();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const {
    isSignedIn,
    handleLogin
  } = useAuthContext();
  const {
    store
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  const preferredUsername = store?.profile?.userId;
  const roomOwnerPreferredUsername = roomData.owner.community_user_id;
  let t0;
  if ($[0] !== htcToken || $[1] !== preferredUsername) {
    t0 = htcToken && preferredUsername ? {
      htcToken,
      preferredUsername
    } : undefined;
    $[0] = htcToken;
    $[1] = preferredUsername;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const authenticatedIdentity = t0;
  let t1;
  if ($[3] !== authenticatedIdentity) {
    t1 = () => getAuthenticatedFollowingsList(authenticatedIdentity);
    $[3] = authenticatedIdentity;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== roomOwnerPreferredUsername) {
    t2 = {
      onSuccess: data => {
        setIsFollowed(checkIsFollowed(data, roomOwnerPreferredUsername));
      }
    };
    $[5] = roomOwnerPreferredUsername;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    mutate: mutateFollowingsData
  } = useSWR(authenticatedIdentity ? "getFollowingsData" : null, t1, t2);
  let t3;
  if ($[7] !== authenticatedIdentity || $[8] !== handleLogin || $[9] !== isFollowed || $[10] !== isSignedIn || $[11] !== mutateFollowingsData || $[12] !== roomOwnerPreferredUsername || $[13] !== setFollowersData) {
    t3 = async () => {
      if (!isSignedIn) {
        handleLogin();
        return;
      }
      if (!authenticatedIdentity || !roomOwnerPreferredUsername) {
        return;
      }
      setIsButtonEnabled(false);
      const followingsData = await mutateFollowingsData();
      const newIsFollowed = checkIsFollowed(followingsData, roomOwnerPreferredUsername);
      if (newIsFollowed !== isFollowed) {
        setIsFollowed(newIsFollowed);
        setFollowersData(prev => {
          if (!prev) {
            return prev;
          }
          const totalItems = prev.totalItems + (newIsFollowed ? 1 : -1);
          return {
            ...prev,
            totalItems
          };
        });
        return;
      }
      const action = isFollowed ? postAuthenticatedUnfollow : postAuthenticatedFollow;
      const postResponse = await action(authenticatedIdentity, roomOwnerPreferredUsername);
      if (postResponse?.status === 200) {
        setIsFollowed(!isFollowed);
        setFollowersData(prev_0 => {
          if (!prev_0) {
            return prev_0;
          }
          const totalItems_0 = prev_0.totalItems + (isFollowed ? -1 : 1);
          return {
            ...prev_0,
            totalItems: totalItems_0
          };
        });
      } else {
        console.error(`${isFollowed ? "Unfollow" : "Follow"} user failed:`, postResponse);
      }
      setIsButtonEnabled(true);
    };
    $[7] = authenticatedIdentity;
    $[8] = handleLogin;
    $[9] = isFollowed;
    $[10] = isSignedIn;
    $[11] = mutateFollowingsData;
    $[12] = roomOwnerPreferredUsername;
    $[13] = setFollowersData;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const handleToggleFollow = t3;
  let t4;
  if ($[15] !== handleToggleFollow || $[16] !== isButtonEnabled || $[17] !== isFollowed) {
    t4 = {
      isFollowed,
      isButtonEnabled,
      handleToggleFollow
    };
    $[15] = handleToggleFollow;
    $[16] = isButtonEnabled;
    $[17] = isFollowed;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};